"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _createIconComponent = _interopRequireDefault(require("../utils/createIconComponent"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const BellIcon = (0, _createIconComponent.default)({
  content: ( /*#__PURE__*/_react.default.createElement("g", null, /*#__PURE__*/_react.default.createElement("path", {
    d: "M8.995 2.097a1 1 0 10-1.99 0C4.72 2.55 3 4.532 3 6.91V10c0 .244-.235.486-.478.672-.3.23-.522.568-.522.947V13h12v-1.382c0-.379-.221-.717-.522-.947-.242-.186-.478-.428-.478-.671V6.91c0-2.378-1.72-4.36-4.005-4.813zM6.268 14a2 2 0 003.464 0H6.268z"
  })))
});
BellIcon.displayName = 'BellIcon';
var _default = exports.default = BellIcon;